import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Path, Tree, TreeNode } from '@s8l/client-tree-lib';

export interface NestedPathElement {
  node?: TreeNode;
  children: NestedPathElement[];
}

@Component({
  selector: 'app-nested-path-selector',
  templateUrl: './nested-path-selector.component.html',
  styleUrls: ['./nested-path-selector.component.scss']
})
export class NestedPathSelectorComponent implements OnInit {
  @Input() public tree: Tree;
  @Input() public readonly: boolean;
  @Input() public element: NestedPathElement;
  @Input() public maxDepth: number;

  @Output() public elementChange = new EventEmitter<NestedPathElement>();

  public path: Path;
  public leafs: Path[];
  public expanded = false;
  public editing = false;

  public ngOnInit() {
    const uri = this.element.node?.path;
    if (uri) {
      this.path = Path.parse(uri);
      this.setupPaths();
    }
  }

  private setupPaths() {
    this.element.children = [];
    if (this.path?.length > 1) {
      const element = this.fromNode(this.element.node, this.maxDepth + 1 - this.path.length);
      this.leafs = this.findLeafs(element);
      this.element.children = element.children;
    } else {
      this.leafs = null;
    }
  }

  public onPathChange(path: Path) {
    this.expanded = false;
    this.element.node = this.tree.get(path);
    this.setupPaths();
    this.notifyChanged();
  }

  public onEditingChange(editing: boolean) {
    this.element.children = [];
  }

  public notifyChanged() {
    this.elementChange.emit(this.element);
  }

  private fromNode(node: TreeNode, depth: number): NestedPathElement {
    const children = !node || depth <= 0 ? [] : node.children.map(c => this.fromNode(c, depth - 1));
    return { node, children };
  }

  private findLeafs(element: NestedPathElement): Path[] {
    const leafs = this.findLeafsRecursive(element);
    if (leafs.length === 0 || (leafs.length === 1 && leafs[0].uri() === element.node?.path)) {
      return null;
    }
    return leafs;
  }

  private findLeafsRecursive(element: NestedPathElement): Path[] {
    if (element.children?.length > 0) {
      return element.children.reduce((a, c) => a.concat(this.findLeafsRecursive(c)), []);
    } else {
      return element.node?.path ? [Path.parse(element.node.path)] : [];
    }
  }
}
